import React, { useEffect, useRef } from 'react';
import { Button } from 'react-bootstrap';
import './ScheduleButton.scss';

const ScheduleButton = ({ children }) => {
  const buttonRef = useRef(null);
  const lastUpdate = useRef(0);

  useEffect(() => {
    const button = buttonRef.current;
    const cursor = button.querySelector('.custom-cursor');
    
    const handleMouseMove = (e) => {
      const now = Date.now();
      if (now - lastUpdate.current < 16) return;
      
      const rect = button.getBoundingClientRect();
      const x = Math.min(Math.max(0, e.clientX - rect.left), rect.width);
      const y = Math.min(Math.max(0, e.clientY - rect.top), rect.height);
      
      cursor.style.transform = `translate(${x}px, ${y}px)`;
      cursor.style.visibility = 'visible';
      lastUpdate.current = now;
    };

    const handleMouseEnter = () => {
      requestAnimationFrame(() => {
        cursor.style.opacity = '1';
        cursor.style.width = '80px';
        cursor.style.height = '80px';
        cursor.style.padding = '10px';
        cursor.style.visibility = 'visible';
        cursor.style.backgroundColor = '#008833';
        cursor.style.border = '2px solid #ffffff';
      });
    };

    const handleMouseLeave = () => {
      requestAnimationFrame(() => {
        cursor.style.opacity = '0';
        cursor.style.width = '0';
        cursor.style.height = '0';
        cursor.style.padding = '0';
        cursor.style.visibility = 'hidden';
        cursor.style.border = 'none';
        cursor.style.transform = 'translate(0, 0)';
      });
    };

    button.addEventListener('mousemove', handleMouseMove);
    button.addEventListener('mouseenter', handleMouseEnter);
    button.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      button.removeEventListener('mousemove', handleMouseMove);
      button.removeEventListener('mouseenter', handleMouseEnter);
      button.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  return (
    <Button ref={buttonRef} className="schedule-btn">
      <span>{children}</span>
      <div className="custom-cursor">
        <span style={{ 
          color: '#ffffff', 
          fontSize: '24px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <span style={{ fontSize: '20px', fontWeight: '200' }}>Go</span>
          <span style={{ fontWeight: '100' }}>→</span>
        </span>
      </div>
    </Button>
  );
};

export default ScheduleButton;